<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_i"></a><a id="page_ii"></a><a id="page_iii"></a><a id="page_iv">Published in 2009 by</a></p><a id="page_iv">
<p class="copyright0">Academy Chicago Publishers</p>
<p class="copyright0">363 West Erie Street</p>
<p class="copyright0">Chicago, Illinois 60654</p>
<p class="copyright1">© 2009 David Schmahmann</p>
<p class="copyright1">Printed in the U.S.A.</p>
<p class="copyright1">All rights reserved.</p>
<p class="copyright0">No part of this book may be reproduced in any form without the express written permission of the publisher.</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data on file with the publisher</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Copyright.vue?7b335cfa